<template>
  <div v-if="!props.hideSidebar" id="sidebar" ref="sidebarEl" class="sidebar p-bx2">
    <div class="sidebar-content">
      <!-- Logo -->
      <div class="logo-section f-ac f-sb p-h12 h-x3 m-tx4 m-bx5">
        <a class="logo" href="/">
          <div v-if="state.currentUser.super_admin" :class="`t-lg link lh-24 ${browsingOtherTeam ? 'restricted bg-dark-gray p-4' : ''}`">
            <div class="f-sb">
              <div :class="`t-lg bold f-ac ${browsingOtherTeam ? 'pink' : 'green'}`">{{ state.currentTeam.name }}</div>
              <donut-form
                v-if="browsingOtherTeam"
                ref="form"
                class="m-b0 f-ac m-lx3"
                :action="`/teams/${state.currentUser.team_id}/switch`"
                method="post"
              >
                <button class="button sm t-sm p-h4 inv"><i class="mi">wrong_location</i></button>
              </donut-form>
            </div>
          </div>
          <cdn-img v-else path="donut_logo_24" />
        </a>
        <div id="sidebar-close" class="link purple" @click="closeSidebar">
          <i class="mi md-18">close</i>
        </div>
      </div>
      <!-- Links -->
      <div v-if="props.sidebarSections" class="links-section">
        <template v-for="(section, idx) in sidebarSections">
          <div v-if="section.header" :key="`sidebar-header-${idx}`" class="m-tx3 m-bx1">
            <div class="t gray">{{ section.header }}</div>
            <div class="h-1 w-100p bg-dark-border" />
          </div>
          <navigation-sidebar-section v-else :key="`sidebar-section-${idx}`" :section="section" />
        </template>
      </div>
    </div>
  </div>
  <!-- Topbar -->
  <Teleport to="#navigation-topbar">
    <navigation-topbar v-if="state.currentUser" :show-sidebar="props.sidebarSections && !props.hideSidebar" @open-sidebar="openSidebar" />
  </Teleport>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  const props = defineProps({
    sidebarSections: { type: Array, default: null },
    hideSidebar: { type: Boolean, default: false },
  });

  const { state } = useStore();

  // Opening/Closing (Mobile/Tablet Only)
  const sidebarEl = ref(null);
  const openSidebar = () => {
    sidebarEl.value.classList.add('open');
  };
  const closeSidebar = () => {
    sidebarEl.value.classList.remove('open');
  };

  // Rendering Logic
  const browsingOtherTeam = computed(() => state.currentUser.super_admin && state.currentTeam.id !== state.currentUser.team_id);
</script>
